import { Logger } from 'besonders-logger'
import { render } from 'solid-js/web'

import { AppRoot } from './App'
import { flushAllPendingBlockContent } from './data/VMs/BlockVM'
import { setupDeepLinks } from './deep-link'
import { notifyToast } from './ui/utils-ui'
import './logger-config' // this is an extra file so it can be imported first
import '@note3/utils/corejs'

import 'virtual:uno.css'
// Self-hosted Roboto (variable, font-display:swap) — bundled into the app so it
// works fully offline and never render-blocks. Used on Linux/Android where no
// native UI font matches; macOS/Windows still win with their system font.
import '@fontsource-variable/roboto'
import './index.css'

const { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.INFO) // eslint-disable-line unused-imports/no-unused-vars

await (async () => {
	// await new Promise(resolve => setTimeout(resolve, 1000))

	window.onerror = (err) => {
		ERROR('[window.onerror]', err)
		notifyToast(err, 'error' as any)
	}

	window.addEventListener('beforeunload', () => {
		// Flush pending block content before page unload to prevent data loss
		// Note: Must complete quickly - browser won't wait for async operations
		void flushAllPendingBlockContent()
	})

	// Handle a note3:// deep link before render so a cold-start link sets the
	// route up-front (avoids a flash of the default start page). Native/Tauri
	// warm links keep arriving via the onOpenUrl listener registered here too.
	await setupDeepLinks()

	render(() => (
		/* <ErrorBoundary //TODO: This didn't seem to work with mobx integration and/or lazy components
			fallback={(err, reset) =>
				ERROR(`<App> caught:`, err) && (
					<div flex='~ col' w-full gap-4>
						<wa-callout variant='danger' open>
							<div flex='~ items-center gap-4' text-xl>
								<div class='i-ph:warning-bold' />
								<strong>Unknown error</strong>
							</div>
							<pre mb-0>{err.message ?? JSON.stringify(err, undefined, 4)}</pre>
							<wa-button mt-4 variant='brand' onclick={() => window.location.hash = '#/'} flex-self-end>Back home</wa-button>
							<wa-button mt-4 ml-2 variant='secondary' onclick={reset} flex-self-end>Retry</wa-button>
						</wa-callout>
					</div>
				)}
		> */
		<AppRoot />
		/* <Routes>
			<Route path='/test' component={TestPage} />
			<Route path='/' component={App} />
		</Routes> */
		/* </ErrorBoundary> */
	), document.getElementById('root') as HTMLElement)
})()
